import { tileLayer } from './MapTilesSearch.utils'
import { DEFAULT_MAPSTYLE, ZONE_LAYOUT_MAPSTYLE } from '@/config'
import { mapStyleService } from '../services/mapStyleService'

const currentYear = new Date().getFullYear()

export const restrictions = [
  {
    name: 'reserved_zone',
    color: 'rgba(150, 150, 150, 0.8)',
  },
  { name: 'polluted_zone', color: 'rgba(194, 46, 0, 0.8)' },
  {
    name: 'underwater_protected_zone',
    color: 'rgba(0, 147, 156, 0.8)',
  },
  {
    name: 'forest_zone',
    color: 'rgba(153, 204, 153, 0.8)',
  },
  { name: 'built_sites_protected_zone', color: 'rgba(51, 51, 51, 0.8)' },
  {
    name: 'watercourse_limit_zone',
    color: 'rgba(0, 51, 102, 0.8)',
  },
  { name: 'forest_limit_zone', color: 'rgba(204, 204, 153, 0.8)' },
  { name: 'not_yet_defined_special_zone', color: 'rgba(0, 0, 0, 0.8)' },
  { name: 'mandatory_planning_zone', color: 'rgba(255, 204, 0, 0.8)' },
  { name: 'archaeological_zone', color: 'rgba(255, 204, 0, 0.8)' },
  { name: 'nature_protection_zone', color: 'rgba(255, 204, 0, 0.8)' },
  { name: 'no_max_cos_zone', color: 'rgba(255, 204, 0, 0.8)' },
  { name: 'other_zone', color: 'rgba(255, 204, 0, 0.8)' },
  { name: 'protected_objects', color: 'rgba(255, 204, 0, 0.8)' },
  { name: 'danger_zone', color: 'rgba(255, 204, 0, 0.8)' },
  { name: 'building_right', color: 'rgba(255, 204, 0, 0.8)' },
  {
    name: 'multiple',
    color: 'rgba(248, 104, 51, 0.8)',
  },
]

export const landLayersMap = (
  landThematic: string,
  map: any,
  // thematic: { legend: any[] },
  // prospects: any,
  favorites: any,
  tags: any = []
  // overridedPlots: any = {}
) => {
  if (
    landThematic !== 'zone_layout' &&
    map?.getStyle()?.name === 'popety-prod-zoning'
  ) {
    // If the layer is not zone layout, remove the existing layer
    mapStyleService.changeBasemap(map, DEFAULT_MAPSTYLE)
  }

  if (landThematic === 'zone_layout') {
    // For zone layout layer, switch to zone layout map style and set 100% transparency
    mapStyleService.changeBasemap(map, ZONE_LAYOUT_MAPSTYLE)

    // Set 100% transparency (opacity = 0) for the land layer
    if (map.getLayer(tileLayer)) {
      map.setPaintProperty(tileLayer, 'fill-opacity', 0)
      map.setPaintProperty(tileLayer, 'fill-color', '#ffffff')
    }
  } else if (landThematic === 'tag') {
    const caseTagExpression: any[] = ['case']

    if (tags && tags.length > 0) {
      // Iterate color values for each tag
      for (const tag of tags) {
        if (tag?.color?.[0] === '#' && tag?.land_ids?.length > 0) {
          const landIds = tag.land_ids.map((id: number) => String(id))

          caseTagExpression.push(
            [
              'any',
              ['in', ['get', 'id'], ['literal', landIds]],
              ['in', ['get', 'land_id'], ['literal', landIds]],
            ],
            tag.color
          )
        }
      }
    }

    // Add default
    caseTagExpression.push('#fff')

    // Change the color
    map.setPaintProperty(
      tileLayer,
      'fill-color',
      tags?.length ? caseTagExpression : '#fff'
    )
  } else if (landThematic === 'favorite') {
    const caseFavoriteExpression: any[] = ['case']
    const landIds = favorites?.map((favorite: { landId: number }) =>
      String(favorite.land_id)
    )

    // Inserate color values for each tag
    caseFavoriteExpression.push(
      [
        'any',
        ['in', ['get', 'id'], ['literal', landIds]],
        ['in', ['get', 'land_id'], ['literal', landIds]],
      ],
      '#00ade6'
    )

    // Add default
    caseFavoriteExpression.push('#fff')

    // Change the color
    map.setPaintProperty(tileLayer, 'fill-color', caseFavoriteExpression)
  } else if (landThematic === 'prospect') {
    const caseProspectExpression: any[] = ['case']
    // const landIds = prospects?.map((id: number) => String(id))

    // Inserate color values for each tag
    // caseProspectExpression.push(
    //   ['in', ['get', 'land_id'], ['literal', landIds]],
    //   '#00ade6'
    // )

    // Add default
    caseProspectExpression.push('#fff')

    // Change the color
    map.setPaintProperty(
      tileLayer,
      'fill-color',
      // prospects?.length ? caseProspectExpression : '#fff'
      caseProspectExpression
    )
  } else if (landThematic === 'official_usage_indice_extracted') {
    let colorExpression = {
      property: 'official_usage_indice_extracted',
      type: 'categorical',
      stops: [
        [true, 'rgba(120,198,121,0.8)'],
        [false, 'rgba(247,252,185,0.8)'],
      ],
    }

    colorExpression = {
      property: 'official_occupation_indice_extracted',
      type: 'categorical',
      stops: [
        [true, 'rgba(120,198,121,0.8)'],
        [false, 'rgba(247,252,185,0.8)'],
      ],
    }
    // Change the color
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (landThematic === 'building_area') {
    const colorExpression = {
      property: landThematic,
      type: 'categorical',
      stops: [
        [true, '#00939c'],
        [false, '#c22e00'],
      ],
    }

    // Change the color
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (
    landThematic === 'average_building_year' ||
    landThematic === 'average_renovation_year'
  ) {
    const colorExpression = {
      property: landThematic,
      // type: 'categorical',
      default: '#f0f0f0',
      stops: [
        [0, '#c22e00'],
        [1940, '#c22e00'],
        [1950, '#d0532b'],
        [1960, '#dd7755'],
        [1970, '#eb9c80'],
        [1980, '#f8c0aa'],
        [1990, '#bae1e2'],
        [2000, '#8cced1'],
        [2010, '#5dbabf'],
        [2016, '#2fa7ae'],
        [currentYear, '#00939c'],
      ],
    }

    // Change the color
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (landThematic === 'unit_nb') {
    const colorExpression = {
      property: landThematic,
      // type: 'categorical',
      default: '#f0f0f0',
      stops: [
        [1, '#fff7fb'],
        [2, '#ece7f2'],
        [3, '#d0d1e6'],
        [4, '#a6bddb'],
        [5, '#74a9cf'],
        [8, '#3690c0'],
        [11, '#0570b0'],
        [15, '#045a8d'],
        [20, '#023858'],
        [1000, '#082649'],
      ],
    }

    // Change the color
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (landThematic === 'highest_building_protected_rank') {
    const colorExpression = {
      property: landThematic,
      default: '#f0f0f0',
      stops: [
        [0, '#f0f0f0'],
        [1, '#74c477'],
        [2, '#fcae91'],
        [3, '#fb6a4a'],
        [4, '#de2d26'],
      ],
    }

    // Change the color
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (landThematic === 'restriction_type') {
    const colorExpression = {
      property: 'restriction_type',
      default: '#f0f0f0',
      type: 'categorical',
      stops: restrictions?.map((them) => [them.name, them.color]),
    }

    // Change the color
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (landThematic === 'listing_rent_last_year') {
    // Rental - Green gradient (#00A550)
    const colorExpression = {
      property: landThematic,
      default: '#f0f0f0',
      stops: [
        [0, '#e6fff0'],
        [currentYear - 9, '#e6fff0'],
        [currentYear - 8, '#b3f5d1'],
        [currentYear - 7, '#80ebb2'],
        [currentYear - 6, '#4de093'],
        [currentYear - 5, '#26d679'],
        [currentYear - 4, '#00cc5f'],
        [currentYear - 3, '#00A550'],
        [currentYear - 2, '#008040'],
        [currentYear - 1, '#005c2e'],
        [currentYear, '#00401f'],
      ],
    }
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (landThematic === 'listing_sale_last_year') {
    // Sale - Orange gradient (#E68600)
    const colorExpression = {
      property: landThematic,
      default: '#f0f0f0',
      stops: [
        [0, '#fff5e6'],
        [currentYear - 9, '#fff5e6'],
        [currentYear - 8, '#ffe4b3'],
        [currentYear - 7, '#ffd380'],
        [currentYear - 6, '#ffc24d'],
        [currentYear - 5, '#ffb11a'],
        [currentYear - 4, '#f59e00'],
        [currentYear - 3, '#E68600'],
        [currentYear - 2, '#b36900'],
        [currentYear - 1, '#804b00'],
        [currentYear, '#4d2d00'],
      ],
    }
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (landThematic === 'construction_permit_last_year') {
    // Permit - Purple gradient (#805AD5)
    const colorExpression = {
      property: landThematic,
      default: '#f0f0f0',
      stops: [
        [0, '#f3e8ff'],
        [currentYear - 9, '#f3e8ff'],
        [currentYear - 8, '#e9d5ff'],
        [currentYear - 7, '#d8b4fe'],
        [currentYear - 6, '#c084fc'],
        [currentYear - 5, '#a855f7'],
        [currentYear - 4, '#9333ea'],
        [currentYear - 3, '#805AD5'],
        [currentYear - 2, '#6b46c1'],
        [currentYear - 1, '#553c9a'],
        [currentYear, '#44337a'],
      ],
    }
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (landThematic === 'transaction_last_year') {
    // Transaction - Coral/Red gradient (#E05252)
    const colorExpression = {
      property: landThematic,
      default: '#f0f0f0',
      stops: [
        [0, '#fce8e8'],
        [currentYear - 9, '#fce8e8'],
        [currentYear - 8, '#f9c4c4'],
        [currentYear - 7, '#f5a0a0'],
        [currentYear - 6, '#f17c7c'],
        [currentYear - 5, '#ec6868'],
        [currentYear - 4, '#e85555'],
        [currentYear - 3, '#E05252'],
        [currentYear - 2, '#b34242'],
        [currentYear - 1, '#863131'],
        [currentYear, '#5a2121'],
      ],
    }
    map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
  } else if (landThematic === 'principal_type') {
    // const uniqValue = thematic?.legend.filter(
    //   (them, index, self) =>
    //     index === self.findIndex((find) => find.value === them.value)
    // )

    // const colorExpression = {
    //   property: landThematic,
    //   default: '#f0f0f0',
    //   type: 'categorical',
    //   stops: uniqValue
    //     ?.filter((them) => them.color)
    //     ?.map((them) => [them.value, them.color]),
    // }

    // Change the color
    map.setPaintProperty(tileLayer, 'fill-color', '#f0f0f0')
  } else {
    const isDifference = landThematic?.split('_')?.[0] === 'difference'
    // const { developmentGroupedPlots, underExploitedGroupedPlots } =
    //   overridedPlots

    const colorExpression = {
      property: landThematic,
      default: '#f0f0f0',
      stops: !isDifference
        ? [
            [0, '#ffbfbf'],
            [25, '#ffc3a5'],
            [50, '#FFE768'],
            [75, '#8ED1A5'],
            [100, '#00441b'],
          ]
        : [
            [-100, '#ffbfbf'],
            [-50, '#ffc3a5'],
            [0, '#f0f0f0'],
            [50, '#8ED1A5'],
            [100, '#00441b'],
          ],
    }

    if (
      landThematic === 'development_score' ||
      landThematic === 'under_exploited_score'
    ) {
      // For score layers, use interpolation expression
      const interpolateExpression = [
        'interpolate',
        ['linear'],
        ['get', landThematic],
        // the defined steps.
        !isDifference ? 0 : -100,
        '#ffbfbf',
        !isDifference ? 25 : -50,
        '#ffc3a5',
        !isDifference ? 50 : 0,
        '#FFE768',
        !isDifference ? 75 : 50,
        '#8ED1A5',
        100,
        '#00441b',
      ]

      map.setPaintProperty(tileLayer, 'fill-color', interpolateExpression)
    } else {
      // For other layers, use the color expression
      map.setPaintProperty(tileLayer, 'fill-color', colorExpression)
    }
  }
}
